export const userData = (() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
        try {
            return JSON.parse(atob(userDataString));
        } catch (error) {
            console.error("Error parsing user data:", error);
            return null;
        }
    } else {
        console.error("User data not found in sessionStorage.");
        return null;
    }
})();
export const getRole = () =>{
    return userData.UROLEID;
}
export const getUserId = () =>{
    return userData.USERID;
}
export const getSubscriberId = () =>{
    return userData.SUBSCRIBERID;
}

export const  getUserName = () =>{
    return userData.USERNAME;
}

export const getExpiryTime = () =>{
    return sessionStorage.getItem("LoginTime")
}

export const setExpiryTime = (expiryTime) =>{
    sessionStorage.setItem("LoginTime",expiryTime);
}
export const  isLoggedin = () =>{
    return userData ? true : false;
} 

export const getCompanyId = () =>{
    return userData.COMPANYID;
} 